// extracted by mini-css-extract-plugin
export default {"header":"TMr71","compare-device":"lDiNL","compare-device__image-container":"ssfAG","compare-device__content":"p8eMF"};